import request from '@/utils/request';
import {loginCompany} from '@/utils/LoginContext';

export async function getOwnerByCompanyUuid(payload) {
  let onlyOnline = false;
  if (payload.onlyOnline)
    onlyOnline = true;
  return request(`/iwms-basic/basic/owner/getByCompanyUuid?companyUuid=${payload.companyUuid}&onlyOnline=${onlyOnline}`);
}

export async function save(payload) {
  return request(`/iwms-basic/basic/owner`,{
    method: 'POST',
    body: payload,
  });
}

export async function onLine(payload) {
  return request(`/iwms-basic/basic/owner/${payload.uuid}/online?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function offLine(payload) {
  return request(`/iwms-basic/basic/owner/${payload.uuid}/offline?version=${payload.version}`, {
    method: 'POST',
  });
}

export async function get(payload) {
  return request(`/iwms-basic/basic/owner/${payload}`);
}

export async function getByCodeAndCompanyUuid(payload) {
  return request(`/iwms-basic/basic/owner/getByCodeAndCompanyUuid?code=${payload.entityCode}&companyUuid=${payload.companyUuid}`);
}

export async function getDefOwner(payload) {
  return request(`/iwms-basic/basic/owner/${payload}/getDefOwner`);
}

export async function modify(payload) {
  return request(`/iwms-basic/basic/owner/modify`,{
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-basic/basic/owner/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function dcbatchsave(payload){
  return request(`/iwms-basic/basic/owner/${payload.uuid}/dcbatchsave?companyUuid=${loginCompany().uuid}`,{
    method:'POST',
    body:payload.dcCodes
  })
}

export async function saveOneDc(payload){
  return request(`/iwms-basic/basic/owner/dc`,{
    method:'POST',
    body:payload
  })
}

export async function remove(payload){
  return request(`/iwms-basic/basic/owner/dc/${payload}/remove`,{
    method:'DELETE'
  })
}
